import * as React from 'react';
import Axios from 'axios';
import type { JsonObject } from '@/app-package';

import errorReporter from '@app/errorReporter';
import { AnsweringOrgGroupDoc, OrgDoc } from '@bb/domain/dist/schemas';

interface ManageGroupListRowProps {
  group: JsonObject<Omit<AnsweringOrgGroupDoc, 'orgs'> & { orgs: OrgDoc[] }>;
  fetchGroups: (setFetching?: boolean) => void;
}

interface ManageGroupListRowState {
  editMode: boolean;
  input: string;
  pending: boolean;
}

class ManageGroupListRow extends React.Component<
  ManageGroupListRowProps,
  ManageGroupListRowState
> {
  constructor(props: ManageGroupListRowProps) {
    super(props);
    this.state = { editMode: false, input: props.group.label, pending: false };
  }

  public handleInput = (ev: React.ChangeEvent<HTMLInputElement>) =>
    this.setState({ input: ev.target.value });

  public updateGroup = async () => {
    const { input } = this.state;
    const {
      group: { id },
      fetchGroups,
    } = this.props;
    try {
      this.setState({ pending: true });
      await Axios.post('/answering/update_group', { id, label: input });
      await fetchGroups(false);
    } catch (err) {
      errorReporter.error(`Error updating group: ${err}`);
    } finally {
      this.setState({ editMode: false, pending: false });
    }
  };

  public deleteGroup = async () => {
    const {
      group: { id },
      fetchGroups,
    } = this.props;
    try {
      this.setState({ pending: true });
      await Axios.post('/answering/delete_group', { id });
      await fetchGroups(false);
    } catch (err) {
      errorReporter.error(`Error deleting group: ${err}`);
    } finally {
      this.setState({ pending: false });
    }
  };

  public enableEditMode = () => this.setState({ editMode: true });

  public disableEditMode = () => {
    const { group } = this.props;

    this.setState({ editMode: false, input: group.label });
  };

  public render() {
    const { editMode, input, pending } = this.state;
    const { group } = this.props;
    return (
      <li className="list-group-item" style={{ display: 'flex' }}>
        <span style={{ marginTop: 'auto', marginBottom: 'auto' }}>
          {editMode ? (
            <input
              className="form-control"
              disabled={pending}
              onChange={this.handleInput}
              placeholder="Enter Group Name"
              value={input}
            />
          ) : (
            group.label
          )}
        </span>
        <span style={{ marginLeft: 'auto' }}>
          {
            // eslint-disable-next-line no-nested-ternary
            pending ? (
              <button disabled className="btn btn-primary">
                <i className="fa fa-spin fa-cog"></i> RESOLVING...
              </button>
            ) : editMode ? (
              <div className="group-list-actions">
                <a onClick={this.disableEditMode} className="btn btn-danger">
                  <i className="fa fa-times"></i>
                </a>
                <a onClick={this.updateGroup} className="btn btn-success">
                  <i className="fa fa-check"></i>
                </a>
              </div>
            ) : (
              <div className="group-list-actions">
                <a
                  onClick={this.enableEditMode}
                  className="btn btn-default"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Edit Group Label"
                >
                  <i className="fa fa-pencil"></i>
                </a>
                <a
                  onClick={this.deleteGroup}
                  className="btn btn-danger"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Delete Group"
                >
                  <i className="fa fa-trash"></i>
                </a>
              </div>
            )
          }
        </span>
      </li>
    );
  }
}

export default ManageGroupListRow;
